import _defineProperty from "/builds/speachme/speachmeDesktop/speach-front/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import { __decorate } from "tslib";
import { Component, Emit, Vue } from "vue-facing-decorator";
import QuestionAnswerImageUploader from "@/components/questions/QuestionAnswerImageUploader.vue";
import ImageUploader from "@/components/imageUploader/ImageUploader.vue";
let FlipCardImageDialog = class FlipCardImageDialog extends Vue {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "uploadApiUrl", '/user/lib/b64photo');
    _defineProperty(this, "displayImageUploader", true);
  }
  onImageUploaded($event) {
    return $event.path;
  }
  closeDialog() {
    this.$emit('dialogClose');
    this.displayImageUploader = false;
  }
};
__decorate([Emit("imgUpdate")], FlipCardImageDialog.prototype, "onImageUploaded", null);
FlipCardImageDialog = __decorate([Component({
  components: {
    ImageUploader,
    QuestionAnswerImageUploader
  },
  emits: ['dialogClose']
})], FlipCardImageDialog);
export default FlipCardImageDialog;